(function() {
  window.adConfigs = window.adConfigs || {};

  const flavours = ['Caramel', 'Peanut Butter', 'Pistachio', 'Raspberry', 'Hazelnut', 'Malt-Cornflakes'];

  function buildFlavourList(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    return 'Six bars: ' + reordered.join(' · ');
  }

  function buildFlavourChips(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    const chips = reordered.map((f, i) =>
      `<span class="bb-flavour-chip">${f}</span>${i < reordered.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
    ).join('');
    return `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${chips}`;
  }

  const selftreatImages = {
    'caramel':      null,
    'peanutbutter': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self-Treat-Peanut-Butter-PDP.png?v=1775653052',
    'pistachio':    null,
    'raspberry':    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_cropped.png?v=1774430529',
    'pretzel':      null,
    'smaltz':       null,
  };

  const selftreatFlavours = {
    'caramel':      'Caramel',
    'peanutbutter': 'Peanut Butter',
    'pistachio':    'Pistachio',
    'raspberry':    'Raspberry',
    'pretzel':      'Hazelnut',
    'smaltz':       'Malt-Cornflakes',
  };

  Object.entries(selftreatFlavours).forEach(([key, displayName]) => {
    window.adConfigs[`selftreat-${key}`] = {
      subline1: "Not a gift. <br>This one's for you.",
      subline2: buildFlavourChips(displayName),
      cartSub:  buildFlavourList(displayName),
      image:    selftreatImages[key],
    };
  });
})();